export const IDLE = 'idle';
export const INITIATED = 'initiated';
export const FETCHED = 'fetched';
export const ERROR = 'error';

export default {
    IDLE,
    INITIATED,
    FETCHED,
    ERROR,
};
